module.exports = __webpack_public_path__ + "img/nurse.7f59be76.webp";